import router from './router';
import * as api from '@/api/auth/is-login';

router.beforeEach((to, from, next) => {
  api
    .get()
    .then(() => {
      if (to.path === '/login') {
        next('/');
      } else {
        next();
      }
    })
    .catch(() => {
      if (to.path === '/') {
        next('/login');
      } else {
        next();
      }
    });
});
